import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImagePreloadService {

    preloadImages(imageUrls: string[]): Promise<any[]> {
        const imagePromises = imageUrls.map((url) => {
            return new Promise<void>((resolve, reject) => {
                const image = new Image();
                image.onload = () => resolve();
                image.onerror = () => reject();
                image.src = url;
            });
        });

        return Promise.all(imagePromises);
    }
}
